import { useState } from "react";
import { toast } from "sonner";
import { AlertOctagon, Loader2, Search, Truck } from "lucide-react";
import { errText } from "@/lib/bf";
import BFGuarantors from "./BFGuarantors";

const FIELDS = [["cui", "CUI"], ["firma", "Nume firmă *", "SC ... SRL"], ["onrc", "Nr. Reg. Com."], ["admin", "Nume administrator *"], ["phone", "Telefon *"], ["email", "E-mail *"],
  ["sediu", "Adresă sediu social *"], ["banca", "Banca"], ["iban", "Cont bancar (IBAN)", "RO49 AAAA 1B31 0075 9384 0000"]];
const LIV = [["liv_adresa", "Stradă, număr, bloc, apartament"], ["liv_localitate", "Localitate"], ["liv_judet", "Județ / sector"], ["liv_cod", "Cod poștal"],
  ["liv_contact", "Persoană de contact la livrare"], ["liv_tel", "Telefon livrare"]];
const WIDE = { cui: "is-wide2", sediu: "is-wide", iban: "is-wide2", email: "is-wide2", liv_adresa: "is-wide" };

const Inp = ({ k, l, ph, d, setD, extra }) => (
  <label className={`bfc-f ${WIDE[k] || ""}`}><span className="st-label">{l}</span>
    <input value={d[k] || ""} placeholder={ph || ""} inputMode={k === "liv_cod" ? "numeric" : k.endsWith("tel") || k === "phone" ? "tel" : undefined} maxLength={k === "liv_cod" ? 6 : undefined}
      onChange={(e) => setD({ ...d, [k]: e.target.value })} data-testid={`bf-contract-${k}`} />{extra}</label>
);

export default function BFContractFields({ d, setD, reader, anaf, ciErr, onCi }) {
  const [busy, setBusy] = useState(false);
  const [bad, setBad] = useState(null);
  const lookup = () => {
    if (!d.cui) return toast.error("Scrie întâi CUI-ul");
    setBusy(true); setBad(null);
    anaf(d.cui).then((r) => {
      setD({ ...d, cui: r.cui, firma: r.firma || d.firma, sediu: r.sediu || d.sediu, onrc: r.onrc || d.onrc });
      const why = r.radiat ? "RADIATĂ" : r.inactiv ? "INACTIVĂ" : "";
      if (why) { setBad({ cui: r.cui, why, stare: r.stare }); toast.error(`Firma apare ${why} la ANAF. Contractul nu se poate genera.`); } else toast.success("Date preluate de la ANAF");
    }).catch((e) => toast.error(errText(e, "Nu am găsit CUI-ul la ANAF"))).finally(() => setBusy(false));
  };
  const cuiBtn = <button type="button" className="st-btn st-btn--light bf-anaf-btn" onClick={lookup} disabled={busy} data-testid="bf-contract-anaf">{busy ? <Loader2 size={14} className="animate-spin" /> : <Search size={14} />} Caută la ANAF</button>;
  return (
    <>
      <div className="bfc-grid">
        {FIELDS.map(([k, l, ph]) => <Inp key={k} k={k} l={l} ph={ph} d={d} setD={setD} extra={k === "cui" ? cuiBtn : null} />)}
      </div>
      {bad && bad.cui === d.cui && <p className="bf-lead-err bf-anaf-bad" data-testid="bf-contract-anaf-blocked"><AlertOctagon size={15} /><span>Firma cu CUI {bad.cui} apare <b>{bad.why}</b> la ANAF{bad.stare ? ` (${bad.stare})` : ""}. Contractul nu se poate genera pentru această firmă.</span></p>}
      <div className="bf-fid bf-liv" data-testid="bf-contract-livrare">
        <h4><Truck size={16} /> Adresă de livrare</h4>
        <p className="st-hint">Lasă gol dacă marfa se livrează la sediul social. Codul poștal se scrie de mână și îl verifică facturarea.</p>
        <div className="bfc-grid">{LIV.map(([k, l]) => <Inp key={k} k={k} l={l} d={d} setD={setD} />)}</div>
      </div>
      <BFGuarantors reader={reader} admin={d.admin} fid={d.fid || []} onChange={(fid) => setD({ ...d, fid })} onCi={onCi} errors={ciErr} />
    </>
  );
}
